import React from "react";
import { Link } from "react-router-dom";
import { hero } from "../../assets";

const Hero = () => {
  return (
    <section
      id="home"
      className="flex justify-start items-start md:flex-row flex-col sm:px-16 px-6 py-6"
    >
      <div className="flex flex-1 flex-col justify-center items-start sm:pl-16 px-0 sm:py-20 pb-10 gap-8">
        <div className="flex flex-col gap-4">
          <h1 className="font-bold sm:text-[60px] text-[44px] sm:leading-[80px]">
            <span className="text-headingPrimary">Prepare </span>
            <span className="text-secondary">for Competitive Exams!</span>
          </h1>
          <p className="text-textSecondary text-[20px] font-normal leading-[32px]">
            One stop solution for all your entrance needs.
          </p>
        </div>
        <Link to="/login">
          <button className="font-medium text-[20px] rounded-md bg-secondary text-primary border-secondary border py-2 px-8">
            Start Now
          </button>
        </Link>
        {/* <div className="text-center pt-6">
          <p className="text-[24px] text-textPrimary font-medium leading-8 uppercase">
            Number of Active Users Right Now
          </p>
          <p className="text-[48px] font-bold text-secondary">20,000+</p>
        </div> */}
      </div>
      <div className="flex flex-[1.5] justify-start items-start relative">
        <img
          src={hero}
          className="sm:object-contain object-left w-[100%] h-[100%]"
          alt=""
        />
      </div>
    </section>
  );
};

export default Hero;
